/**
 * Root Layout Component
 * 
 * Wraps all routes with FCM integration and provides Outlet for nested routes
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import FCMIntegration from '../FCMIntegration';

const RootLayout = () => {
  return (
    <FCMIntegration>
      <Outlet />
    </FCMIntegration>
  );
};

export default RootLayout;
